export class CRMTable {
	constructor(vroc, mode, job) {
		this.vroc = vroc;
		this.mode = mode;
		this.job = job;
		this.id = 'crm-table';
	}

	async init() {
		await this.vroc.attachComponent({
			id: this.id,
			xmlUrl: `/ajax.php?mid=47&action=loadTable&mode=${this.mode ?? ''}&job=${this.job ?? ''}`,
			templateId: 'mod_crm/table',
			node: '.orders__table-wrapper'
		});

		this._bindEvents();
	}

	_bindEvents() {
		
	}

	doSearch(parent)
	{
		let _this = this;
		clearTimeout(this.delayTimer);
		this.delayTimer = setTimeout(function() {
			_this.loadTable(parent)
		}, 400);
	}

	loadTable(parent)
	{
		let formData = new FormData();
		formData.append('action', 'loadTable');
		if (parent.name == 'filter_dates' || parent.name == 'search')
		{
			formData.append(parent.name, parent.value);
		}
		else
		{
			formData.append('mode', this.mode);
			formData.append('job', this.job);
		}
		
		document.querySelector('.orders__table-wrapper .loader').classList.add('active');

		ajax.post('/ajax.php?mid=47', 
			formData, 
			{
				dataType: 'text',
				success: (text) => 
				{
					this.vroc.updateComponent(this.id, text);
					document.querySelector('.orders__table-wrapper .loader').classList.remove('active');
				}
			}
		);
	}

	async applyFilter(filter, value) {
		const formData = new FormData();
		formData.append('action', 'loadTable');
		//formData.append('mode', this.mode);
		formData.append(filter, value);
		
		document.querySelector('.orders .loader').classList.add('active');

		const response = await fetch('/ajax.php?mid=47', {
			method: 'POST',
			body: formData
		});

		const xmlText = await response.text();
		this.vroc.updateComponent(this.id, xmlText); // Обновляем только таблицу
		cdocument.querySelector('.orders__table-wrapper .loader').classList.remove('active');
	}

	destroy() {
		// Очищаем компонент
		this.vroc.detachComponent(this.id);
	}
}